import React from 'react';
import { BootstrapTable, TableHeaderColumn } from 'react-bootstrap-table';
import { Link } from 'react-router';
import { I18N, ROLES } from '../../../../constants';
import AuthorizedComponent from '../../../../components/AuthorizedComponent';
import { Button } from 'react-bootstrap';

const abnormalityLinkFormatter = (cell, row) => {
    if (row.genericAbnormalityType === 'MANIFEST_BASED') {
        return (
            <Link
                to={`/manifests/${row.manifestNavigation.manifestId}/abnormality/${
                    row.abnormalityType
                }/${row.abnormalityId}`}
            >
                {row.name}
            </Link>
        );
    }
    return (
        <Link to={`/runs/${row.runId}/abnormality/${row.abnormalityType}/${row.abnormalityId}`}>
            {row.name}
        </Link>
    );
};

const AbnormalitiesListSimple = ({ abnormalities, handleCreateGenericClick }) => (
    <div>
        <BootstrapTable data={abnormalities} hover>
            <TableHeaderColumn dataField="abnormalityId" isKey hidden>
                ID
            </TableHeaderColumn>
            <TableHeaderColumn dataField="abnormalityName" dataFormat={abnormalityLinkFormatter}>
                Name
            </TableHeaderColumn>
            <TableHeaderColumn
                dataField="abnormalityType"
                dataFormat={type => I18N.ABNORMALITIES[type]}
            >
                Type
            </TableHeaderColumn>
            <TableHeaderColumn
                dataField="abnormalityStatus"
                width="150"
                dataFormat={status => I18N.ABNORMALITY_STATUS[status]}
            >
                Status
            </TableHeaderColumn>
        </BootstrapTable>
        <AuthorizedComponent requiredRoles={[ROLES.ABNORMALITY_GENERIC_CREATOR]}>
            <Button bsStyle="success" style={{ marginTop: 10 }} onClick={handleCreateGenericClick}>
                Create generic abnormality
            </Button>
        </AuthorizedComponent>
    </div>
);

export default AbnormalitiesListSimple;
